const styles = ({ COLORS }) => ({
  container: {
    marginLeft: 'auto',
    borderLeft: '1px solid #dedede',
    paddingLeft: '20px',
    maxWidth: '33%',
    display: 'flex',
    alignItems: 'center'
  }
})

export default styles
